export class TopUpViewModel {
  acn: number;
  amount: number;
  area: string;
  firstname: string;
  lastname: string;
  portalId: string;
  memberId: string;
  successUrl: string;
  failureUrl: string;

  constructor(acn: number, amount: number, portalId: string, memberId: string, successUrl: string, failureUrl: string) {
    this.acn = acn;
    this.amount = amount;
    this.portalId = portalId;
    this.memberId = memberId;
    this.successUrl = successUrl;
    this.failureUrl = failureUrl;
  }
}
